module.exports = __webpack_public_path__ + "img/logo2.44d411be.png";